import { render } from "./TeacherNavbar.vue?vue&type=template&id=b7423e04"
import script from "./TeacherNavbar.vue?vue&type=script&lang=js"
export * from "./TeacherNavbar.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__